import React, { Component } from "react";
import { Popup, Button } from "devextreme-react";
import Form, { Item } from "devextreme-react/form";
import Api from "Api/Api";
import { editorConfig, template_type } from "formFields";
import Keywords from "components/AdminComponents/Keywords";

export default class MailTemplateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      edit: false,
      templates: null,
      templateID: null,
      templateForm: {
        template_name: null,
        content: null,
        type: null,
      },
    };
    this.resetForm = () => {
      this.setState({
        templateForm: {
          template_name: null,
          content: null,
          type: null,
        },
        templateID: null,
      });
    };
    this.togglePopup = () => {
      this.setState({ visible: !this.state.visible });
    };
    this.createEditTemplate = (e) => {
      e.preventDefault();
      if (this.state.edit) {
        Api.editMailTemplate(
          this.state.templateID,
          this.state.templateForm
        ).then((response) => {
          if (response.status === 200) {
            this.resetForm();
            this.props.getTemplate(response.data);
            this.togglePopup();
          }
        });
      } else {
        Api.createMailTemplate(this.state.templateForm).then((response) => {
          if (response.status === 201) {
            this.resetForm();
            this.props.getTemplate(response.data);
            this.togglePopup();
          }
        });
      }
    };
    this.deleteTemplate = () => {
      Api.deleteMailTemplate(this.state.templateID).then((response) => {
        this.props.getTemplate(null);
        this.togglePopup();
      });
    };
    this.getTemplateType = () => {
      let existing_template_type = (this.state.templates || []).map((temp) => {
        return temp.type;
      });
      if (!this.state.edit) {
        return template_type.filter((ele) => {
          if (ele !== "Custom") {
            return !existing_template_type.includes(ele);
          }
          return true;
        });
      }
      return template_type;
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      edit: props.edit,
      templates: props.templates,
      templateID: props.template && props.template.id,
      templateForm: {
        template_name: props.template && props.template.template_name,
        content: props.template && props.template.content,
        type: props.template && props.template.type,
      },
    };
  }

  render() {
    return (
      <>
        <Button
          onClick={this.togglePopup}
          text={this.state.edit ? "Edit Template" : "Create Template"}
        />
        <Popup
          visible={this.state.visible}
          onHiding={this.togglePopup}
          closeOnOutsideClick={true}
          height={"50%"}
          width={"50%"}
        >
          <form onSubmit={this.createEditTemplate}>
            <Form formData={this.state.templateForm}>
              <Item
                dataField="template_name"
                isRequired
                editorOptions={{
                  stylingMode: "underlined",
                }}
              />
              <Item
                dataField="type"
                isRequired
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: this.getTemplateType(),
                  stylingMode: "underlined",
                }}
              />
              <Item
                helpText={"click here for list of keywords"}
                render={(e) => {
                  return <Keywords />;
                }}
              />
              <Item
                caption="Body"
                dataField="content"
                isRequired
                editorType="dxHtmlEditor"
                editorOptions={{
                  toolbar: { items: editorConfig },
                  height: "170px",
                }}
              />
            </Form>
            <button className="btn btn-success" type="submit">
              {this.state.edit ? "Edit" : "Save"}
            </button>
            {this.state.edit ? (
              <button
                className="btn btn-danger"
                onClick={this.deleteTemplate}
                type="button"
              >
                Delete
              </button>
            ) : null}
          </form>
        </Popup>
      </>
    );
  }
}
